import { render, staticRenderFns } from "./DisastersSection.vue?vue&type=template&id=8fbb49ac&scoped=true&"
import script from "./js/disasters-section.js?vue&type=script&lang=js&"
export * from "./js/disasters-section.js?vue&type=script&lang=js&"
import style0 from "./DisastersSection.vue?vue&type=style&index=0&id=8fbb49ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbb49ac",
  null
  
)

export default component.exports